export default __webpack_public_path__ + "static/media/bear.06e5a793.png";